import { SET_INDUSTRY, SKIP_AND_GO_TO_TAGS_SELECTOR } from '../mainActionTypes';

export default function industryReducer(state = { isCustom: true, industryText: '' }, action) {
  const { type, payload } = action;
  let currentState = {};
  let industry = '';
  switch (type) {
    case SET_INDUSTRY:
      industry = payload.industryText || '';
      currentState = { ...state, industryText: industry, industry: payload.industry, isCustom: payload.isCustom };
      return currentState;
    case SKIP_AND_GO_TO_TAGS_SELECTOR:
      industry = '';
      currentState = { ...state, industryText: industry, industry, isCustom: true };
      return currentState;

    default:
      return state;
  }
}
